import * as Blockly from "blockly";

export class FieldChevronBase extends Blockly.Field<boolean> {
  public static SERIALIZABLE = true;
  public override SERIALIZABLE = true;

  public static override fromJson<T extends FieldChevronBase>(
    this: new (expanded?: boolean | string) => T,
    options: Blockly.FieldConfig & { expanded?: boolean | string },
  ): T {
    return new this(options.expanded ?? false);
  }

  constructor(expanded: boolean | string = false) {
    super(FieldChevronBase.normalizeValue(expanded));
  }

  protected override doClassValidation_(
    newValue?: boolean | string,
  ): boolean | null {
    return FieldChevronBase.normalizeValue(newValue);
  }

  public setExpanded(expanded: boolean): void {
    this.setValue(expanded);
  }

  private static normalizeValue(value: boolean | string | undefined): boolean {
    return value === true || value === "true";
  }
}
